import { organizationSchema } from './organization-schema';
import { websiteSchema } from './website-schema';
import { tutorialsSchema } from './tutorials-schema';
import { healthcareSchema } from './healthcare-schema';
import { breadcrumbSchema } from './breadcrumb-schema';
import { navigationSchema } from './navigation-schema';
import { faqSchema } from './faq-schema';

// Get the base URL, defaulting to production URL if window is not available
const getBaseUrl = () => {
  if (typeof window !== 'undefined') {
    return window.location.origin;
  }
  // Default to production URL for SSR and search engines
  return 'https://scienzahealth.com';
};

// Function to add base URL to all URLs in an object
const addBaseUrl = (obj: any): any => {
  if (typeof obj !== 'object' || obj === null) return obj;
  
  if (Array.isArray(obj)) {
    return obj.map(item => addBaseUrl(item));
  }

  const newObj: any = {};
  for (const [key, value] of Object.entries(obj)) {
    if (typeof value === 'string' && (
      key === 'url' || 
      key === '@id' || 
      key === 'target' || 
      key === 'contentUrl' || 
      key === 'embedUrl' || 
      key === 'thumbnailUrl'
    )) {
      // Always ensure URLs are absolute
      newObj[key] = value.startsWith('/') ? `${getBaseUrl()}${value}` : value;
    } else if (typeof value === 'object' && value !== null) {
      newObj[key] = addBaseUrl(value);
    } else {
      newObj[key] = value;
    }
  }
  return newObj;
};

export const getAllSchemas = () => {
  const schemas = [
    organizationSchema,
    websiteSchema,
    tutorialsSchema,
    healthcareSchema,
    breadcrumbSchema,
    navigationSchema,
    faqSchema
  ];

  // Add base URL to all schemas
  const schemasWithBaseUrl = schemas.map(schema => addBaseUrl(schema));
  
  return JSON.stringify(schemasWithBaseUrl);
};